const downloadsDictionary = {
  'downloadsPanel.exportCancelled': 'Export cancelled',
  'downloadsPanel.exportFailed': 'Export failed',
  'downloadsPanel.exportInProgress': 'Export in progress...',
  'downloadsPanel.exportInQueue': 'Export in queue',
  'downloadsPanel.retry': 'Retry',
  'downloadsPanel.retrying': 'Retrying',
  'downloadsPanel.download': 'Download',
  'downloadsPanel.cancel': 'Cancel',
  'downloadsPanel.cancelling': 'Cancelling',
  'downloadsPanel.close': 'Close',
  'downloadsPanel.dismiss': 'Clear',
  'downloadsPanel.dismissAll': 'Clear all',
  'downloadsPanel.keepTrackOfYourExports': 'Keep track of your exports',
  'downloadsPanel.emptyExportsText': 'Files you exported will appear here to download.'
};
export function defaultDownloadsTranslate(key, params) {
  const dictionaryValue = downloadsDictionary[key];

  if (!params) {
    return dictionaryValue;
  }

  return Object.entries(params).reduce((value, [paramName, paramValue]) => {
    return value.replace(`{{${paramName}}}`, String(paramValue));
  }, dictionaryValue);
}